export default from './SummaryPage';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/index.js